<template>
  <div class="">
    <div
      class="
        flex
        justify-between
        px-1.5
        py-1.5
        gap-4
        bg-gray-50
        w-3/4
        border border-opacity-25
        mx-auto
        rounded-xl
      "
    >
      <button
        class="
          px-2
          p-3
          w-full
          text-sm
          focus:outline-none
          focus:ring-2
          focus:ring-offset-2
          focus:ring-blue-500
          rounded-lg
          tracking-wider
        "
        :class="{
          'bg-blue-700 border rounded-lg text-white text-xs tracking-wider':
            title == selectedTitle,
          'hover:bg-blue-50': title !== selectedTitle,
        }"
        v-for="title in tabTitles"
        :key="title"
        @click="selectedTitle = title"
      >
        {{ title }}
      </button>
    </div>
    <slot />
  </div>
</template>

<script>
import { provide, ref } from "vue";

export default {
  setup(props, { slots }) {
    const tabTitles = ref(slots.default().map((tab) => tab.props.title));
    const selectedTitle = ref(tabTitles.value[0]);

    provide("selectedTitle", selectedTitle);

    return {
      tabTitles,
      selectedTitle,
    };
  },
};
</script>
